import { merge } from 'lodash';
import { useDispatch } from 'react-redux';

import { type PublicClip } from '@air/api';
import { updateContentCollectionClipsAction } from '@air/feature-content-collection/redux';

import { usePublicWorkspace } from '~/components/PublicWorkspaceProvider';
import { useEventSubscription } from '~/hooks/useEventSubscription';

export const useHandleContentCollectionClipMediaUpdated = (clips: PublicClip[]) => {
  const { workspaceId } = usePublicWorkspace();
  const dispatch = useDispatch();

  useEventSubscription({
    currentWorkspaceId: workspaceId,
    event:
      clips.length > 0
        ? {
            eventType: 'System.Clip.Media.updated',
          }
        : undefined,
    options: {
      onUpdate: ({ data: { clipId, updates: assets } }) => {
        const localClip = clips.find((c) => c.id === clipId);

        if (!localClip) {
          return;
        }

        dispatch(
          updateContentCollectionClipsAction({
            clips: [merge({}, localClip, { assets })],
          }),
        );
      },
    },
  });
};
